<div class="mt-4">
  <h2 class="text-lg mb-1"><strong>Clinic & Provider Information:</strong></h2>
  <hr class="bg-green mb-2" style="height: 2px;" />

  @if (mode === 'edit') {
    <p><strong>Clinic 1:</strong></p>
    <app-clinic-search-dropdown
      [required]="true"
      [dropdownLabel]="'Select First Clinic'"
      [dropdownSelectionFormControl]="firstClinicCtrl"
      [showError]="true">
    </app-clinic-search-dropdown>
    @if (getClinicAddresses(firstClinicCtrl.value).length) {
      <div class="mb-4">
        <strong>Clinic 1 Address:</strong>
        @for (address of getClinicAddresses(firstClinicCtrl.value); track address) {
          <div>{{address}}</div>
        }
      </div>
    }
    <app-provider-multiselect
      [required]="true"
      [label]="'Select Providers'"
      [selectionFormControl]="firstProvidersCtrl"
      [showError]="!!firstClinicCtrl.value"
      [clinicId]="firstClinicCtrl.value"
      [originalClinicId]="firstClinicIdValue ?? undefined"
      [selectedOptions]="allFirstProviderIds",
      [hasOtherProvider]="hasFirstOtherProvider",
      [showRequestRemovalClinicOption]="false">
    </app-provider-multiselect>
    @if (firstClinicProps?.otherProviderName && !removeFirstClinicOtherProviderPanel) {
      <div class="other-provider-info-edit-mode">
        <div>
          <p><strong>Add New Provider:</strong></p>
          <p><strong>Provider Name: </strong>{{firstClinicProps?.otherProviderName}}</p>
          <p><strong>Provider NPI: </strong>{{firstClinicProps?.otherProviderNpi}}</p>
        </div>
        <app-remove-button
          (onRemove)="onFirstClinicOtherProviderRemoved()">
        </app-remove-button>
      </div>
    }
    @if ((firstClinicProps?.requestedRemovalProviders?.length ?? 0 > 0)  && !removeFirstRemoveProviderPanel) {
      <div class="bg-red-100 border border-red-400  px-4 py-3 rounded relative m-2 flex justify-between">
        <div>
          <p><strong>Remove Provider from Clinic:</strong></p>
          @for (providerName of getFirstClinicRemovalProviders(); track providerName) {
            <div>
              <strong>Provider Name: </strong> {{providerName}}
            </div>
          }
        </div>
        <app-remove-button
          (onRemove)="onFirstClinicRemoveRequestRemoved()">
        </app-remove-button>
      </div>
    }
    <div class="mt-8">
      <p><strong>Clinic 2 (Optional):</strong></p>
      @if (showPendingSecondClinicRemoval && secondClinicProps?.pendingRemovalClinicId) {
        <div class="bg-red-100 border border-red-400 px-4 py-3 rounded relative my-2">
          <p><strong>Remove {{secondClinicProps?.pendingRemovalClinicId}}</strong></p>
        </div>
      }
      <div class="w-full col-span-2 flex flex-col gap-y-4">
        <div class="flex items-start gap-2">
          <div class="w-full">
            <app-clinic-search-dropdown
              [required]="false"
              [dropdownLabel]="'Select Second Clinic'"
              [dropdownSelectionFormControl]="secondClinicCtrl"
              [showError]="false">
            </app-clinic-search-dropdown>
          </div>
          @if (secondClinicCtrl.value && allowSecondProviderRemoval) {
            <button
              type="button"
              class="mt-4 inline-flex h-12 w-12 shrink-0 items-center justify-center text-3xl font-bold leading-none text-red-600 hover:text-red-800"
              aria-label="Remove Clinic 2"
              title="Remove Clinic 2"
              (click)="onRemoveSecondClinic()"
            >
              &times;
            </button>
          }
        </div>
      </div>
      @if (getClinicAddresses(secondClinicCtrl.value).length) {
        <div class="mb-4">
          <strong>Clinic 2 Address:</strong>
          @for (address of getClinicAddresses(secondClinicCtrl.value); track address) {
            <div>{{address}}</div>
          }
        </div>
      }
      @if (!!secondClinicCtrl?.value) {
        <app-provider-multiselect
          [required]="!!secondClinicCtrl.value"
          [label]="'Select Providers'"
          [selectionFormControl]="secondProvidersCtrl"
          [showError]="true"
          [clinicId]="secondClinicCtrl.value"
          [originalClinicId]="secondClinicIdValue ?? undefined"
          [selectedOptions]="allSecondProviderIds",
          [hasOtherProvider]="hasSecondOtherProvider",
          [showRequestRemovalClinicOption]="false">
        </app-provider-multiselect>
      }
      @if (secondClinicProps?.otherProviderName && !removeSecondClinicOtherProviderPanel) {
        <div class="other-provider-info-edit-mode">
          <div>
            <p><strong>Add New Provider:</strong></p>
            <p><strong>Provider Name: </strong>{{secondClinicProps?.otherProviderName}}</p>
            <p><strong>Provider NPI: </strong>{{secondClinicProps?.otherProviderNpi}}</p>
          </div>
          <app-remove-button
            (onRemove)="onSecondClinicOtherProviderRemoved()">
          </app-remove-button>
        </div>
      }
      @if ((secondClinicProps?.requestedRemovalProviders?.length ?? 0 > 0) && !removeSecondRemoveProviderPanel) {
        <div class="bg-red-100 border border-red-400  px-4 py-3 rounded relative m-2 flex justify-between">
          <div><p><strong>Remove Provider from Clinic:</strong></p>
          @for (providerName of getSecondClinicRemovalProviders(); track providerName) {
            <div>
              <strong>Provider Name: </strong> {{providerName}}
            </div>
          }
        </div>
        <app-remove-button
          (onRemove)="onSecondClinicRemoveRequestRemoved()">
        </app-remove-button>
      </div>
    }
  </div>
} @else {
  @if (hasFirstClinicId) {
    <p>
      <strong>Clinic 1:</strong> {{firstClinicProps?.clinicName || firstClinicIdValue}}
    </p>
  }
  @if (firstClinicProps?.clinicAddresses?.length) {
    <div>
      <strong>Clinic 1 Address:</strong>
      @for (address of firstClinicProps?.clinicAddresses; track address) {
        <div>{{address}}</div>
      }
    </div>
  }
  @if (firstClinicProps?.providers?.length ?? 0 > 0 || firstClinicProps?.pendingProviders?.length ?? 0 > 0) {
    <div>
      <p><strong>Clinic 1 Providers:</strong></p>
      <ul class="provider-list">
        @for (providerName of getFirstClinicProvidersAfterPending(); track providerName) {
          <li>
            {{providerName}}
          </li>
        }
      </ul>
    </div>
  }
  @if (firstClinicProps?.otherProviderName) {
    <div class="other-provider-info">
      <p><strong>Add New Provider:</strong> Pending Approval</p>
      <p><strong>Provider Name: </strong>{{firstClinicProps?.otherProviderName}}</p>
      <p><strong>Provider NPI: </strong>{{firstClinicProps?.otherProviderNpi}}</p>
    </div>
  }
  @if (firstClinicProps?.requestedRemovalProviders?.length ?? 0 > 0) {
    <div class="bg-red-100 border border-red-400  px-4 py-3 rounded relative m-2">
      <p><strong>Remove Provider from Clinic:</strong></p>
      @for (providerName of getFirstClinicRemovalProviders(); track providerName) {
        <div>
          <strong>Provider Name: </strong> {{providerName}}
        </div>
      }
    </div>
  }
  @if (hasSecondClinicId) {
    <p class="mt-2">
      <strong>Clinic 2:</strong> {{secondClinicProps?.clinicName || secondClinicIdValue}}
    </p>
  }
  @if (secondClinicProps?.clinicAddresses?.length) {
    <div>
      <strong>Clinic 2 Address:</strong>
      @for (address of secondClinicProps?.clinicAddresses; track address) {
        <div>{{address}}</div>
      }
    </div>
  }
  @if (hasSecondClinicProvidersToDisplay()) {
    <div>
      <p><strong>Clinic 2 Providers:</strong></p>
      <ul class="provider-list">
        @for (providerName of getSecondClinicProvidersAfterPending(); track providerName) {
          <li>
            {{providerName}}
          </li>
        }
      </ul>
    </div>
  }
  @if (secondClinicProps?.otherProviderName) {
    <div class="other-provider-info">
      <p><strong>Add New Provider:</strong> Pending Approval</p>
      <p><strong>Provider Name: </strong>{{secondClinicProps?.otherProviderName}}</p>
      <p><strong>Provider NPI: </strong>{{secondClinicProps?.otherProviderNpi}}</p>
    </div>
  }
  @if (secondClinicProps?.requestedRemovalProviders?.length ?? 0 > 0) {
    <div class="bg-red-100 border border-red-400  px-4 py-3 rounded relative m-2">
      <p><strong>Remove Provider from Clinic:</strong></p>
      @for (providerName of getSecondClinicRemovalProviders(); track providerName) {
        <div>
          <strong>Provider Name: </strong> {{providerName}}
        </div>
      }
    </div>
  }
  @if (showPendingSecondClinicRemoval && secondClinicProps?.pendingRemovalClinicId) {
    <div class="bg-red-100 border border-red-400 px-4 py-3 rounded relative m-2">
      <p><strong>Remove {{secondClinicProps?.pendingRemovalClinicId}}</strong></p>
    </div>
  }
}
</div>

